import React, {useState} from "react";
import {Accordion, Card} from 'react-bootstrap';

const FAQ = () => {
  const [activeKey, setActiveKey] = useState(null);

  const items = [
    {
      key: "0",
      question: "What's the story behind this project?",
      answer: "This project started as a hackathon entry for the Untitled NFT hackathon 2020. This is our first hackathon so it is very exciting to participate and prepare something functional. The development started on Oct. 9 and was done mainly during the weekends. All we can say is that NFTs world is super exciting!"
    },
    {
      key: "1",
      question: "What it has to do with eggs?",
      answer: "We think this is a nice and interesting way of NFT farming comparison and gamification with the real world. There is an incubation period for eggs to hatch. Similarly, here you have to wait for your NFTs to be ready."
    },
    {
      key: "2",
      question: "Why you build on Matic?",
      answer: "Matic is super cool with their fast and cheap transactions, EVM compatibility and the bridge. Also, they are sponsors of the Untitled NFT hackathon ;)"
    },
    {
      key: "3",
      question: "What are the NFTs?",
      answer: "NFT stands for non-fungible token. It is a unique token that you can own on the Blockchain. Our NFTs are not easily accessible, you need to farm them!"
    },
    {
      key: "4",
      question: "Where can I use my NFTs?",
      answer: "NFTs that you farm are the standard ERC-721 tokens that are stored in your wallet. You can send, trade, sell, burn them or do anything else that is possible with this standard."
    },
    {
      key: "5",
      question: "Why not every token has a reward bonus?",
      answer: "This was decided to prevent a possible SPAM and cheating on farming our governance token (NEGG). We whitelist ERC20 tokens that are legit and widely used. In the future, we plan to transfer the ownership to the DAO so NEGG token owners can decide which tokens to include."
    },
    {
      key: "6",
      question: "What is DAO?",
      answer: "DAO stands for decentralized autonomous organization. Our intention is to transfer the ownership to the owners of our governance token (NEGG) to decide the future of this project. Also DAO can help with a possible SPAM prevention by providing on-chain censorship, for example, by deciding which new farms to accept and which ones are inappropriate."
    },
    {
      key: "7",
      question: "What is the purpose of locking up my ERC20 tokens?",
      answer: "There are many uses cases for that. One of them is that when you lock up your tokens for a certain period of time, these tokens cannot be sold or transferred and you become a real HODLer. Another use case is for project owners to reward their top HODLers, for example, those that HODL >0.1% of tokens can claim some special limited edition NFT. These are the examples, but of course, the possibilities are endless!"
    },
    {
      key: "8",
      question: "Will I lose my locked up tokens?",
      answer: "The tokens will be returned together with the NFT once you claim it. Then you can use it freely as you did before."
    },
    {
      key: "9",
      question: "Do you support every ERC20 token?",
      answer: "Currently we do not support ERC20 tokens with a transfer fee. Do not use it, else you risk losing it."
    },
  ];

  const faqCards = items.map(item =>
    <Card key={item.question}>
      <Accordion.Toggle as={Card.Header} eventKey={item.key}>
        {item.question}<i className={"faq-icon arrow-up float-right " + (activeKey === item.key ? 'active' : '')}/>
      </Accordion.Toggle>
      <Accordion.Collapse eventKey={item.key}>
        <Card.Body>{item.answer}</Card.Body>
      </Accordion.Collapse>
    </Card>
  );

  return (
    <section id="faq">
      <div className="px-4 py-4 container-fluid">
        <div className="row no-gutters">
          <div className="col-10 offset-1 text-center">
            <h2>FAQ</h2>
            <hr className="hr-line1"/>
            <Accordion className="my-5" onSelect={setActiveKey}>
              {faqCards}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  )
};

export default FAQ;

